import { useTranslation } from 'react-i18next'
import { Library } from 'lucide-react'
import { EntityPageHeader } from '@/shared/components'
import { AdminLanding } from '../components'

export function AdminLandingPage() {
  const { t } = useTranslation()

  return (
    <div>
      <EntityPageHeader
        icon={Library}
        title={t('administration.title', 'Référentiels')}
        subtitle={t('administration.subtitle', 'Gestion des référentiels')}
      />
      <AdminLanding />
    </div>
  )
}
